var map = {
	"./Attack on Titan.webp": 7848,
	"./Bleach.png": 1266,
	"./BleexBub.png": 9156,
	"./Boku Dake Ga Inai Machi.jpg": 8298,
	"./Boku no Hero Academia.webp": 8308,
	"./Code-Geass.png": 4520,
	"./Cowboy Bebop.png": 7196,
	"./Drifters.png": 9176,
	"./GTO.png": 959,
	"./GamePageCovers/gamehom-Bleach.png": 4339,
	"./GamePageCovers/gamehom-Naruto.png": 5301,
	"./GamePageCovers/gamehom-One-Piece.png": 2025,
	"./GamePageCovers/gamehom-OnePunch.png": 8646,
	"./GamePageCovers/gamehom-dragonball.jpg": 2532,
	"./Haikyu.png": 9660,
	"./Jujutsu Kaisen.jpg": 8442,
	"./One Punch Man.webp": 3707,
	"./OnePunchimage/GAME START-onepunch.png": 3670,
	"./OnePunchimage/onepunch-game-over-image.png": 5439,
	"./OnePunchimage/onepunch-image-background.jpg": 3276,
	"./OnePunchimage/onepunch-image-background.png": 4584,
	"./Shigatsu -Wa- Kimi -No -Uso.png": 7597,
	"./Tokyo Revengers.png": 1594,
	"./Toradora.jpg": 4659,
	"./Yahari Ore no Seishun Love Comedy wa Machigatteiru..png": 9575,
	"./animeship.jpg": 509,
	"./back-nature.jpg": 2080,
	"./bleachimage/bkeach-game-over-background.jpg": 8555,
	"./bleachimage/bleach-GAME START.png": 8774,
	"./bleachimage/bleach-image-background.jpg": 2424,
	"./cloud and sea.jpg": 2878,
	"./dona-prof-pic-08.png": 2055,
	"./forlandingpage-v1.png": 7656,
	"./gifs/batrus-member.png": 6399,
	"./gifs/daivo-member.png": 697,
	"./gifs/dona-member.png": 5984,
	"./gifs/malco-member.png": 5672,
	"./john-prof-pic-07.png": 623,
	"./logo512.png": 9292,
	"./newsback.png": 8483,
	"./one-piece-background.jpg": 1029,
	"./prince of tennis.jpeg": 3897,
	"./school-life-anime.jpg": 9823,
	"./sea-sea.jpg": 6848,
	"./seaonepiece.jpg": 4328,
	"./spy-x-family-02.png": 6522,
	"./tokyo goul.jpg": 8076,
	"./vinland saga.jpg": 4427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;